import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false); // Loader state
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    address: "",
        country: "",
        city: "",
        zip: "",
        latitude: "",
        image: "",
        longitude: "",
  });

  const userId = sessionStorage.getItem("userId");
  const userToken = sessionStorage.getItem("userToken");

  const fetchProfile = async () => {
    try {
      const response = await axios.get(
        `https://ecom.testingwebsitelink.com/api/get-profile/${userId}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      const profileData = response.data.data;
      setProfile(profileData);
      setFormData(profileData);
      setPreviewImage(profileData.image);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };
  
  useEffect(() => {
      fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file, // Store the image file
      }));
      setPreviewImage(URL.createObjectURL(file)); // Show preview
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setLoading(true); // Start Loader
  
    const formDataToSend = new FormData();
    for (const key in formData) {
      if (key === "image" && formData[key] instanceof File) {
        formDataToSend.append(key, formData[key]); // Append file correctly
      } else {
        formDataToSend.append(key, formData[key]);
      }
    }
  
    try {
      const response = await axios.post(
        `https://ecom.testingwebsitelink.com/api/update-profile/${userId}`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data", // Correct content type
          },
        }
      );
  
      setProfile(response.data.data);
      setPreviewImage(response.data.data.image); // Update image preview
      setIsOpen(false); // Close modal
      window.location.reload(); // Refresh the page
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setLoading(false); // Stop Loader
    }
  };
  
 
  if (!profile || loading) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto mt-10 p-6 bg-[#fec73180] border-dashed shadow-lg rounded-lg border-2 border-[#fec731]">
      {/* Profile Details */}
      <div className="flex items-center space-x-4">
        <img
          src={profile.image}
          alt="Profile"
          className="w-20 h-20 rounded-full border-4 border-[#fec731] shadow-md"
        />
        <div>
          <h2 className="text-xl font-semibold text-white">
            {profile.first_name} {profile.last_name}
          </h2>
          <p className="text-white">{profile.email}</p>
        </div>
      </div>

      <div className="mt-6 text-left">
        <h3 className="text-lg font-semibold text-white">User Details</h3>
        <p className="text-white"><strong>Address:</strong> {profile.address}</p>
        <p className="text-white"><strong>City:</strong> {profile.city}</p>
        <p className="text-white"><strong>Country:</strong> {profile.country}</p>
      </div>

      {/* Edit Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="mt-6 bg-[#FEC831] hover:bg-transparent border-2 hover:border-2 border-[#fec731] text-black px-4 py-2 rounded-md transition-all font-semibold"
      >
        Edit Profile
      </button>

      {/* Update Profile Popup */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 updateprofile z-40">
          <div className="bg-[#808080] border-dashed rounded-lg shadow-lg w-96 p-6 relative">
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              ✖
            </button>

            <h2 className="text-xl font-semibold mb-4 text-white">Update Profile</h2>

            <form onSubmit={handleUpdateProfile} className="space-y-3">
              <div className="form-group mt-3 text-center">
                <div className="text-center">
                  <label htmlFor="imageUpload" className="cursor-pointer">
                    {previewImage ? (
                      <img
                        src={previewImage}
                        alt="Profile Preview"
                        className="w-20 h-20 rounded-full border-4 border-[#fec731] shadow-md mx-auto"
                      />
                    ) : (
                      <div className="image-placeholder bg-gray-200 p-4 rounded-lg">
                        Upload Image
                      </div>
                    )}
                  </label>
                  <input
                    type="file"
                    id="imageUpload"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="hidden"
                  />
                </div>
              </div>

              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="First Name"
                className="w-full p-2 rounded-lg focus:ring focus:ring-yellow-300 formfiels"
                required
              />

              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="Last Name"
                className="w-full p-2 rounded-lg focus:ring focus:ring-yellow-300 formfiels"
                required
              />


              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="House Address"
                className="w-full p-2 rounded-lg focus:ring focus:ring-yellow-300 formfiels"
                rows={2}
                required
              ></textarea>

              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City"
                className="w-full p-2  rounded-lg focus:ring focus:ring-yellow-300 formfiels"
                required
              />

              <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleChange}
                placeholder="Country"
                className="w-full p-2  rounded-lg focus:ring focus:ring-yellow-300 formfiels"
                required
              />

              <input
                type="text"
                name="zip"
                value={formData.zip}
                onChange={handleChange}
                placeholder="Zip Code"
                className="w-full p-2  rounded-lg focus:ring focus:ring-yellow-300 formfiels"
                required
              />
              <button
                type="submit"
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-2 rounded-lg transition-all font-semibold"
              >
                 {loading ? "Updating..." : "Save Changes"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
